<template>
  <div class="mobile-content5">
    <div class="title-container">
      <div class="title-dec-left">
        <img src="@/assets/image/title-dec.png" alt="title decoration left" />
      </div>
      <div class="title-text">联系我们</div>
      <div class="title-dec-right">
        <img src="@/assets/image/title-dec.png" alt="title decoration right" />
      </div>
    </div>

    <div class="kefu">
      客服阿颜
    </div>

    <div class="kefu-code">
      <img
        src="https://ustatic.hudongmiao.com/miao/common/kefu-code_176899052055684a11f.webp"
        alt="客服二维码"
      />
    </div>

    <div class="contact-text">
      <div class="line">15300439684</div>
      <div class="line">（微信同号）</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileContent5',
};
</script>

<style lang="less" scoped>
.mobile-content5 {
  width: 100%;
  margin-top: 44px;

  .title-container {
    height: 38px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-end;
    gap: 12px;

    .title-dec-left {
      img {
        width: 61px;
        height: 21px;
        display: block;
        object-fit: contain;
      }
    }

    .title-text {
      font-weight: 700;
      font-size: 26px;
      color: #FFFFFF;
      align-self: flex-end;
      line-height: 1;
    }

    .title-dec-right {
      img {
        width: 61px;
        height: 21px;
        display: block;
        object-fit: contain;
        transform: scaleX(-1);
      }
    }
  }

  .kefu {
    margin-top: 37px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #FFFFFF;
    line-height: 32px;
  }

  .kefu-code {
    margin-top: 11px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 138px;
      height: auto;
      display: block;
    }
  }

  .contact-text {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 20px;
    color: #FFFFFF;
    line-height: 26px;

    .line {
      line-height: 26px;
    }
  }
}
</style>
